mutation UpdatePlatformMenuItems($ids: [ID!]!, $input: UpdatePlatformMenuItemsInput!) {
  updatePlatformMenuItems(ids: $ids, input: $input) {
    id
    index
    label
    linkType
    href
    targetType
    targetId
    targetTitle
    visibilityConditions {
      userType
      countries {
        type
        countryCodes
      }
      applicationPlatforms {
        type
        platforms
      }
    }
    targetUrl
    publishAt
  }
}
